<template>
  <div class="side-bar" :class="{ closed: !sideOpen }">
    <div class="side-header">
      <span
        @click="$store.commit('updateSideOpen')"
        v-if="$store.getters.isMobile"
      >
        <span v-if="sideOpen" class="close-toggle"
          ><font-awesome-icon icon="times"
        /></span>
        <span v-else><font-awesome-icon icon="bars"/></span>
      </span>
      <h3>{{this.$store.getters.user["company name"]}}</h3>
    </div>
    <div class="profile-image-container" v-if="sideOpen">
      <div
        class="profile-image"
        :style="{ 'background-image': `url(${userImage})` }"
      />
    </div>
    <router-link to="/newinvoice/create/new/" class="btn green center icon" v-if="hasInvoiceAccess">
      <span>+</span> New invoice
    </router-link>
    <h4 @click="()=>toggleSection('filter-invoices')" v-if="hasInvoiceAccess">
      Filter invoices
      <span :class="{isOpen: openModules.includes('filter-invoices')}">
        <font-awesome-icon icon="caret-left" />
      </span>
    </h4>
    <ul :class="{isOpen: openModules.includes('filter-invoices')}" v-if="hasInvoiceAccess">
      <li
        v-for="count in Object.keys(counts)"
        :key="count"
        :class="{
          selected:
            (count === 'All jobs' && pageTitle === 'Recent jobs') ||
            count === pageTitle
        }"
        @click="() => linkClick(count)"
      >
        {{ count }} <span class="pill"> {{ counts[count] }}</span>
      </li>
    </ul>
    <h4 @click="()=>toggleSection('settings')">
      Settings
      <span :class="{isOpen: openModules.includes('settings')}">
        <font-awesome-icon icon="caret-left" />
      </span>
    </h4>
    <ul :class="{isOpen: openModules.includes('settings')}">
      <li
        v-if="hasInvoiceAccess"
        :class="{ selected: $route.path === '/edituser' }"
        @click="() => linkClick('invoice-settings')"
      > Company / invoice settings
      </li>
      <li
        v-else
        :class="{ selected: $route.path === '/edituser' }"
        @click="() => linkClick('invoice-settings')"
      > Company
      </li>
      <li
        :class="{ selected: $route.path === '/modules' }"
        @click="() => linkClick('modules', { link: '/modules' })"
      > Modules
      </li>
    </ul>
    <span v-for="category in [...Object.keys(moduleManager)].filter(key => key !== 'accessOnly')" :key="category">
      <h4 @click="()=>toggleSection(category)">
        {{ category }}
        <span :class="{isOpen: openModules.includes(category)}">
          <font-awesome-icon icon="caret-left" />
        </span>
      </h4>
        <ul :class="{isOpen: openModules.includes(category)}">
          <li
              v-for="(linkItem, index) in [...moduleManager[category]].filter(i => i.active)"
              :key="index + '-' + category"
              :class="{ selected: $route.path === linkItem.link }"
              @click="() => linkClick(linkItem.ref, linkItem)"
            > {{ linkItem.name }}
          </li>
        </ul>
    </span>

    <button class="red center log-out-btn" @click="logOutUser">Log out</button>
  </div>
</template>

<script>
import userImage from "../assets/userImage.png";
import router from "../router";
export default {
  name: "Sidebar",
  data: () => ({
    userImage,
    openModules: ['filter-invoices']
  }),
  computed: {
    hasInvoiceAccess () {
      return this.$store.getters.hasInvoiceAccess
    },
    moduleManager () {
      return this.$store.getters.moduleManager.data;
    },
    sideOpen() {
      return this.$store.getters.sideOpen;
    },
    counts() {
      return this.$store.getters.counts;
    },
    pageTitle() {
      if(this.$route.path === '/') return "Recent jobs"
      return this.$route.params.terms;
    }
  },
  methods: {
    toggleSection(section) {
      this.openModules=[section]
    },
    linkClick(link, linkItem) {
      const { getters, commit } = this.$store
      getters.sideOpen && getters.isMobile && commit("updateSideOpen");
      if (linkItem) {
        router.push(linkItem.link)
      } else {
        switch(link){
          case "All jobs":
            router.push("/")
            break;
          case 'invoice-settings':
            router.push("/edituser")
            break;
          default:
            if(this.$route.fullPath === '/'){
              router.push('/search/filter/' + link)
            } else {
              router.push('/')
                .then(() => router.push('/search/filter/' + link))
            }
        }
      }

      document.body.scrollTop = 0; 
      document.documentElement.scrollTop = 0; 
    },
    logOutUser(){
      router.push('/')
      this.$store.commit('logOutUser')
    }
  }
};
</script>

<style lang="scss">
@import "../styles/colors.scss";
@import "../styles/vars.scss";
.side-bar {
  z-index: 3;
  position: fixed;
  background-color: $lightGray;
  width: $side-bar-width;
  height: 100vh;
  font-weight: bold;
  transition: all 0.05s;
  display: flex;
  flex-flow: column;
  & > span {
    width: 100%;
  }
  & > *, & span h4 {
    width: 90%;
    margin: 0 auto;
  }
  h4, & span h4 {
    color: $maroon;
    font-size: 1.3em;
    font-weight: 900;
    margin-bottom: 8px;
    margin-top: 22px;
    display: flex;
    cursor: pointer;
    span {
      height: 15px;
      width: 15px;
      text-align: center;
      color: rgb(110, 110, 110);
      border-radius: 50%;
      transition: transform .3s;
      margin-left: auto;
      display: block;
      transform: rotate(0deg);
      &.isOpen {
        transform: rotate(-90deg);
      }
    }
  }
  .profile-image-container {
    height: 130px;
    width: 130px;
    margin-bottom: 25px;
    margin-top: -110px;
    .profile-image {
      border-radius: 50%;
      width: 130px;
      height: 130px;
      background-color: lightblue;
      border: 10px solid #fff;
      background-position: center;
      background-size: contain;
    }
    @media screen and (max-height: 750px){
      display: none;
    }
  }
  ul {
    width: 100%;
    list-style-type: none;
    padding: 0;
    color: $maxGray;
    margin-bottom: 0px;
    overflow: hidden;
    transition: max-height 0s;
    max-height: 0;
    &.isOpen {
      transition: max-height .5s ease-in;
      max-height: 500px;
    }
    li {
      padding: 13px 10px 10px 10px;
      display: flex;
      transition: all 0.2s;
      span {
        margin-left: auto;
      }
      .pill {
        transition: background-color 0.2s;
        margin-top: -4px;
      }
      &.selected {
        background-color: rgb(245, 245, 245);
        color: $darkBlue;
        & .pill {
          background-color: $darkBlue;
        }
      }
      &:hover {
        padding-left: 20px;
        cursor: pointer;
        background-color: rgb(206, 206, 206);
        color: #000;
        & .pill {
          background-color: $darkBlue;
        }
      }
      &.selected:hover {
        background-color: rgb(255, 255, 255);
      }
    }
  }
  .log-out-btn {
    margin-top: auto;
    margin-bottom: 13px;
  }
}
.mobileView .side-bar {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}
.side-header {
  width: 100%;
  background-color: $maroon;
  margin-bottom: 32px;
  height: $header-height;
  display: flex;
  transition: all 0.05s;
  @media screen and (max-height: 750px){
    height: 50px;
  }
  h3 {
    color: #fff;
    font-size: 1.4rem;
    padding: 0;
    padding-top: 12px;
    padding-left: 15px;
    margin: 0;
  }
  & > span {
    height: 50px;
    width: 50px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s;
    &:hover {
      margin-right: 10px;
      background-color: $darkMaroon;
      cursor: pointer;
    }
    & span {
      font-size: 1.1rem;
      opacity: 0.6;
    }
  }
}
.mobileView .side-header h3 {
  padding-left: 0;
  font-size: 1rem;
  padding-top: 17px;
}

.side-bar.closed {
  width: 240px;
  height: 50px;
  overflow: hidden;
  box-shadow: none;
  background: none;
  border-radius: 10px;
  top: 5px;
  left: 5px;
  .side-header {
    background-color: rgba(0, 0, 0, 0.3);
  }
}
</style>
